const Control = {

  init: () => { },

  evaluateButton: {
    disable: () => $('#evaluate').addClass('pure-button-disabled'),
    enable: () => $('#evaluate').removeClass('pure-button-disabled'),
    click: () => $('#evaluate').click()
  },
  clearButton: {
    toggle: (v) => $("#clear").toggle(v)
  },
  selectCardsNotice: {
    toggle: (v) => $("#please-select-cards").toggle(v)
  },
  reloadNotice: {
    show: () => $('#please-reload').show()
  },
  waitNotice: {
    show: () => $('#please-wait').show(),
    hide: () => $('#please-wait').hide()
  },

  toggleWildCards: function (v) {
    document.getElementById('wild-card').setAttribute('fill-opacity', v)
  }
}

export default Control